import {ModuleConfiguration} from "../router/model/UserPermission";
import {LoanArchieModuleName} from "../utils/names/optionalModuleNames";

export const LoanArchieModuleConfiguration = new ModuleConfiguration(LoanArchieModuleName,
    [
        LoanArchieModuleName
    ]
);

export default LoanArchieModuleConfiguration;